const assetsSliderOpenKey = 'media-viewer-assets-slider-open';

/** Whether the media viewer assets slider was left expanded (desktop) */
export function getStoredAssetsSliderOpen() {
  try {
    return localStorage.getItem(assetsSliderOpenKey) === 'true';
  } catch {
    return false;
  }
}

export function storeAssetsSliderOpen(isOpen: boolean) {
  try {
    localStorage.setItem(assetsSliderOpenKey, String(isOpen));
  } catch {
    // ignore
  }
}
